// utils
import axios from "src/utils/axios";

// ----------------------------------------------------------------------

const API_ENDPOINTS = {
    getUser: "/account/info",
    //
    modifyAccount: `/account/update_base_info`,
    modifyPassword: `/settings/account/profile/reset_password`,
    //
    checkGuide: "/user_guide/progress",
    updateGuide: "/user_guide/update_progress",
    //
    getRestoreID: "/user_chat/get_restore_id",
    setRestoreID: "/user_chat/update_restore_id",
    //
    needReward: "/user/need_reward"
};

// ----------------------------------------------------------------------

const getUser = () => axios.get(`${ API_ENDPOINTS.getUser }`);

const modifyAccount = (request) => axios.post(`${ API_ENDPOINTS.modifyAccount }`, { ...request });

const modifyPassword = (request) => axios.post(`${ API_ENDPOINTS.modifyPassword }`, { ...request });

const checkGuide = () => axios.get(`${ API_ENDPOINTS.checkGuide }`);

const updateGuide = (request) => axios.post(`${ API_ENDPOINTS.updateGuide }`, { ...request });

const getRestoreID = () => axios.get(`${ API_ENDPOINTS.getRestoreID }`);

const setRestoreID = (id) => axios.post(`${ API_ENDPOINTS.setRestoreID }`, { restore_id: id });

const checkMigrationUser = () => axios.get(`${ API_ENDPOINTS.needReward }`);

// ----------------------------------------------------------------------

export {
    getUser as getUserAPI,
    //
    modifyAccount as modifyAccountAPI,
    modifyPassword as modifyPasswordAPI,
    //
    checkGuide as checkGuideAPI,
    updateGuide as updateGuideAPI,
    //
    getRestoreID as getRestoreIDAPI,
    setRestoreID as setRestoreIDAPI,
    //
    checkMigrationUser as checkMigrationUserAPI
};
